import { render, staticRenderFns } from "./PastYears.vue?vue&type=template&id=c8973848&"
import script from "./PastYears.vue?vue&type=script&lang=js&"
export * from "./PastYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports